'use strict';

/** @type {import('./functionCall')} */
module.exports = Function.prototype.call;



//////////////////
// WEBPACK FOOTER
// ./~/call-bind-apply-helpers/functionCall.js
// module id = 212
// module chunks = 0